import type { Messages } from './types';

export const uk: Messages = {
  helpMenu: 'Довідка',
  tutorial: 'Підручник…',
  language: 'Мова…',
  keyboardShortcuts: 'Клавіатурні скорочення…',
  languageTitle: 'Мова',
  languageHint: 'Оберіть мову для екрана привітання, підручника та меню Довідка.',
  languageEnglish: 'English',
  languageUkrainian: 'Українська',
  close: 'Закрити',
  next: 'Далі',
  back: 'Назад',
  done: 'Готово',
  skip: 'Пропустити',
  welcomeTitle: 'Pixotah',
  welcomeText:
    'Багатошаровий фоторедактор у браузері. Файли не залишають ваш пристрій — усі операції рахує відеокарта.',
  welcomeNew: 'Новий документ',
  welcomeOpen: 'Відкрити зображення',
  welcomeDrop: 'Або просто перетягніть файл у вікно.',
  welcomeTutorial: 'Пройти тур',
  tutorialTitle: 'Ласкаво просимо до Pixotah',
  tutorialSteps: [
    {
      title: 'Документи',
      body: 'Створіть документ через Файл → New або відкрийте зображення / PDF. Усе лишається на вашому пристрої — нічого не завантажується в хмару.',
    },
    {
      title: 'Інструменти',
      body: 'Ліва панель: Move, виділення, Brush, Type (T), фігури тощо. Утримуйте або клацніть правою кнопкою для вкладених інструментів. Параметри активного інструмента — у верхній смузі.',
    },
    {
      title: 'Шари',
      body: 'Збирайте зображення в панелі Layers справа. Подвійний клік по шару відкриває Layer Style. Opacity і режим накладання працюють як у Photoshop.',
    },
    {
      title: 'Текст',
      body: 'Оберіть Type (T), клацніть на полотні й друкуйте. Шрифт, розмір, колір, жирний і курсив — у смузі параметрів або Properties. Подвійний клік по тексту — знову редагування.',
    },
    {
      title: 'Панелі',
      body: 'Смуга іконок біля панелей відкриває Brush, Character, Info тощо. Вкладки: Swatches / History і Layers / Channels / Paths. F7 — Layers, F9 — History.',
    },
    {
      title: 'Скорочення',
      body: 'Повний список: Довідка → Keyboard Shortcuts. Ctrl+Z — скасувати, Ctrl+S — зберегти PSD, Tab — сховати панелі.',
    },
  ],
};
